import { SCREEN_NAME, CLICK_ACTIONS } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const terminalStateAlertScreenviewEvent = (
    screenViewEvent: AnalyticsContextValue["screenViewEvent"],
    errorCode: string,
): void => {
    screenViewEvent({
        category: SCREEN_NAME.ORDER_TERMINAL_STATE_ALERT,
        context: errorCode,
    });
};

export const terminalStateAlertCtaClickEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    ctaType: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.ORDER_TERMINAL_STATE_ALERT,
        action: CLICK_ACTIONS.CLICK_CTA_ON_TERMINAL_STATE_ALERT,
        context: ctaType,
    });
};
